/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExportSupplementPdf200Response
 */
export interface ExportSupplementPdf200Response {
    /**
     * Unique request ID for tracking (null if cached)
     * @type {string}
     * @memberof ExportSupplementPdf200Response
     */
    requestId?: string | null;
    /**
     * Status of the PDF generation
     * @type {string}
     * @memberof ExportSupplementPdf200Response
     */
    status: ExportSupplementPdf200ResponseStatusEnum;
    /**
     * S3 key where the PDF is/will be stored
     * @type {string}
     * @memberof ExportSupplementPdf200Response
     */
    s3Key: string;
    /**
     * Pre-signed URL for downloading the PDF (only if status is completed)
     * @type {string}
     * @memberof ExportSupplementPdf200Response
     */
    downloadUrl?: string | null;
    /**
     * Whether the PDF was already cached
     * @type {boolean}
     * @memberof ExportSupplementPdf200Response
     */
    cached?: boolean | null;
}


/**
 * @export
 */
export const ExportSupplementPdf200ResponseStatusEnum = {
    Processing: 'processing',
    Completed: 'completed'
} as const;
export type ExportSupplementPdf200ResponseStatusEnum = typeof ExportSupplementPdf200ResponseStatusEnum[keyof typeof ExportSupplementPdf200ResponseStatusEnum];


/**
 * Check if a given object implements the ExportSupplementPdf200Response interface.
 */
export function instanceOfExportSupplementPdf200Response(value: object): value is ExportSupplementPdf200Response {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('s3Key' in value) || value['s3Key'] === undefined) return false;
    return true;
}

export function ExportSupplementPdf200ResponseFromJSON(json: any): ExportSupplementPdf200Response {
    return ExportSupplementPdf200ResponseFromJSONTyped(json, false);
}

export function ExportSupplementPdf200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportSupplementPdf200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'requestId': json['requestId'] == null ? undefined : json['requestId'],
        'status': json['status'],
        's3Key': json['s3Key'],
        'downloadUrl': json['downloadUrl'] == null ? undefined : json['downloadUrl'],
        'cached': json['cached'] == null ? undefined : json['cached'],
    };
}

export function ExportSupplementPdf200ResponseToJSON(json: any): ExportSupplementPdf200Response {
    return ExportSupplementPdf200ResponseToJSONTyped(json, false);
}

export function ExportSupplementPdf200ResponseToJSONTyped(value?: ExportSupplementPdf200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requestId': value['requestId'],
        'status': value['status'],
        's3Key': value['s3Key'],
        'downloadUrl': value['downloadUrl'],
        'cached': value['cached'],
    };
}

